import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BasketItem } from './../components/basket/basket-item';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportableService {
    constructor(private http: HttpClient) { }

    public getROTE(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'Reports/getreport?id=' + id).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/pdf');
                resolve(blob);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }


    public getJobReport(id, status): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'Reports/getJobReport?id=' + id + '&status=' + status).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/pdf');
                resolve(blob);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }
        // <!-- <a href="/HostedFiles/EquipFiles/{{row.file_Id}}/{{row.file_Name}}" download ></a> -->

    public downloadFile(directory,fileId,fileName): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + directory + '/' + fileId + '/' + fileName).subscribe(data => {
                resolve(data)
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }

      public getUploadedFile(direct: string, id: string, file_name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl +'Reports/GetUploadedFile?_directory=' + direct + '&_id=' + id + '&_fileName=' + file_name ).subscribe(data => {
        console.log("returen");
        console.log(data);
        let blob = this.convertBase64toBlob(data.base64, data.mimeType);
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

    public getBatch(data: Array<any>): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post<any>(environment.apiUrl + 'Inspection/postBatch', data).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/pdf');
                resolve(blob);
            }, error => {
                reject();
            });
        });
    }
    public getRegister(data: Array<any>): Promise<any> {
        //console.log(data);
        return new Promise((resolve, reject) => {
            this.http.post<any>(environment.apiUrl + 'Inspection/postRegister', data).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/pdf');
                resolve(blob);
            }, error => {
                reject();
            });
        });
    }

    public getBatchExcel(data: Array<any>): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post<any>(environment.apiUrl + 'Equipment/postBatchExcel', data).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
                resolve(blob);
            }, error => {
                reject();
            });
        });
    }
    public getRegisterExcel(data: Array<any>): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post<any>(environment.apiUrl + 'Equipment/postRegisterExcel', data).subscribe(data => {
                let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
                resolve(blob);
            }, error => {
                reject();
            });
        });
    }

    convertBase64toBlob(content, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;
        let byteCharacters = window.atob(content); //method which converts base64 to binary
        let byteArrays = [
        ];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, {
            type: contentType
        }); //statement which creates the blob
        return blob;
    }
}
